import React, { Suspense } from 'react';
import { BusyIndicator } from '@sba/design-system';
import ShellBar from './AppListingShellBar';

export default function AppsListLayout({ children }: { children: React.ReactNode }) {
  return (
    <Suspense fallback={<BusyIndicator active delay={100} size="L" />}>
      <div id="nu-layout">
        <ShellBar />
        <div id="nu-content">
          <div className="container-fluid container-fluid--main">
            <div className="container">{children}</div>
          </div>
        </div>
      </div>
    </Suspense>
  );
}
